var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1024"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$route.params._giftcard ? _c('span', [_vm._v("상품권 상세")]) : _c('span', [_vm._v("상품권 등록")])]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0 pr-md-1",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "blue",
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v("기본정보")], 1), _c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "브랜드",
      "placeholder": " ",
      "items": _vm.brands,
      "item-text": "name",
      "item-value": "code",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.brand,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "brand", $$v);
      },
      expression: "giftcard.brand"
    }
  }), _c('v-select', {
    staticClass: "mt-4",
    attrs: {
      "label": "카테고리",
      "placeholder": " ",
      "items": _vm.categories,
      "item-text": "name",
      "item-value": "code",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.category,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "category", $$v);
      },
      expression: "giftcard.category"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "상품권이름",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.name,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "name", $$v);
      },
      expression: "giftcard.name"
    }
  }), _vm.$route.params._giftcard ? _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "상품권코드(대대행)",
      "readonly": "",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard._id,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "_id", $$v);
      },
      expression: "giftcard._id"
    }
  }) : _vm._e(), _c('giftcard-thumb', {
    staticClass: "mt-4",
    model: {
      value: _vm.giftcard.thumb,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "thumb", $$v);
      },
      expression: "giftcard.thumb"
    }
  })], 1)], 1)], 1), _c('v-col', {
    staticClass: "py-0 pl-md-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mx-1 mt-4 mt-md-0"
  }, [_c('v-card-title', [_c('v-select', {
    attrs: {
      "label": "구분",
      "placeholder": " ",
      "items": _vm.modes,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.mode,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "mode", $$v);
      },
      expression: "giftcard.mode"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-0",
    attrs: {
      "label": "순서",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.sequence,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "sequence", $$v);
      },
      expression: "giftcard.sequence"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "권종",
      "type": "number",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.faceamt,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "faceamt", $$v);
      },
      expression: "giftcard.faceamt"
    }
  }), _c('v-row', [_c('v-col', [_c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "현재 api 가격",
      "type": "number",
      "placeholder": " ",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: _vm.giftcard.cpamt,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "cpamt", $$v);
      },
      expression: "giftcard.cpamt"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "api 할인율",
      "type": "number",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.cpamtRate,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "cpamtRate", $$v);
      },
      expression: "giftcard.cpamtRate"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "api 가격",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: _vm.cpamt,
      callback: function ($$v) {
        _vm.cpamt = $$v;
      },
      expression: "cpamt"
    }
  })], 1)], 1), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "재고",
      "placeholder": " ",
      "disabled": _vm.isBulk,
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.stock,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "stock", $$v);
      },
      expression: "giftcard.stock"
    }
  }), _vm.giftcard.mode === 'paper' ? _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "최소 구매 가능 수량(지류)",
      "type": "number",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.minimumPurchase,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "minimumPurchase", $$v);
      },
      expression: "giftcard.minimumPurchase"
    }
  }) : _vm._e(), _c('giftcard-cp-price-dialog', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-4",
          attrs: {
            "hide-details": "",
            "width": "100%",
            "color": "yellow lighten-2"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("CP")])];
      }
    }])
  }, 'giftcard-cp-price-dialog', {
    _giftcard: _vm.$route.params._giftcard
  }, false))], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 align-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "blue",
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v("제공업체 "), _c('v-spacer'), _c('v-select', {
    staticClass: "col-auto pa-0 mt-0",
    attrs: {
      "items": _vm.platforms,
      "item-text": "text",
      "item-value": "value",
      "placeholder": ":: 플랫폼 ::",
      "hide-details": "",
      "disabled": !!_vm.giftcard._id
    },
    model: {
      value: _vm.giftcard.platform,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "platform", $$v);
      },
      expression: "giftcard.platform"
    }
  })], 1), _c('v-divider'), _vm.giftcard.platform && _vm.giftcard.mode == 'mobile' ? _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "상품권 코드",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.code,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "code", $$v);
      },
      expression: "giftcard.code"
    }
  }), _vm.giftcard.platform == 'galaxia' ? _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.kindTypes,
      "label": "kindType",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.kindType,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "kindType", $$v);
      },
      expression: "giftcard.kindType"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.saleTypes,
      "label": "saleType",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.saleType,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "saleType", $$v);
      },
      expression: "giftcard.saleType"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.messageTypes,
      "label": "messageType",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.messageType,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "messageType", $$v);
      },
      expression: "giftcard.messageType"
    }
  })], 1)], 1) : _vm._e(), _vm.giftcard.platform == 'barocon' ? _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "캠페인코드",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.campaignCode,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "campaignCode", $$v);
      },
      expression: "giftcard.campaignCode"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "blue",
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v("과금 및 진열설정")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.enableds,
      "item-text": "text",
      "value": "value",
      "label": "비회원",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.unknownEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "unknownEnabled", $$v);
      },
      expression: "giftcard.unknownEnabled"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  })], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.enableds,
      "item-text": "text",
      "value": "value",
      "label": "normal",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.normalEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "normalEnabled", $$v);
      },
      expression: "giftcard.normalEnabled"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "normal(%)",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.normalCommission,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "normalCommission", $$v);
      },
      expression: "giftcard.normalCommission"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.enableds,
      "item-text": "text",
      "value": "value",
      "label": "vip",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.vipEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "vipEnabled", $$v);
      },
      expression: "giftcard.vipEnabled"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "vip(%)",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.vipCommission,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "vipCommission", $$v);
      },
      expression: "giftcard.vipCommission"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.enableds,
      "item-text": "text",
      "value": "value",
      "label": "vvip",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.vvipEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "vvipEnabled", $$v);
      },
      expression: "giftcard.vvipEnabled"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "vvip(%)",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.giftcard.vvipCommission,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "vvipCommission", $$v);
      },
      expression: "giftcard.vvipCommission"
    }
  })], 1)], 1)], 1)], 1), _vm.isBulk ? _c('giftcard-options', {
    attrs: {
      "giftcard": _vm.giftcard
    }
  }) : _vm._e(), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "blue",
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v("상세정보")], 1), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm.loaded ? _c('naver-smarteditor', {
    model: {
      value: _vm.giftcard.content,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "content", $$v);
      },
      expression: "giftcard.content"
    }
  }) : _vm._e()], 1)], 1), ['payletter', 'barocon', 'chlifes'].includes(_vm.giftcard.platform) ? _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "blue",
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v("사용정보")], 1), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.giftcard.sendMethod,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "sendMethod", $$v);
      },
      expression: "giftcard.sendMethod"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "알림톡(텍스트)",
      "value": "ATS"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "친구톡(이미지포함)",
      "value": "FMS"
    }
  })], 1)], 1), _vm.giftcard.sendMethod === 'FMS' ? _c('v-card-text', [_c('giftcard-send-image', {
    model: {
      value: _vm.giftcard.sendImage,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "sendImage", $$v);
      },
      expression: "giftcard.sendImage"
    }
  })], 1) : _vm._e(), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-textarea', {
    staticClass: "mt-0 py-0",
    attrs: {
      "outlined": "",
      "rows": "8"
    },
    model: {
      value: _vm.giftcard.sendInfo,
      callback: function ($$v) {
        _vm.$set(_vm.giftcard, "sendInfo", $$v);
      },
      expression: "giftcard.sendInfo"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }